import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { publish } from '@stubhub/pubsub-utils';
import FeatureToggle from '@stubhub/react-feature-toggle';
import { connect } from '@stubhub/react-store-provider';

import withHeader from '../../common/higherOrderComponents/withHeader';
import BrandDriver from '../../modules/react-brand-driver';
import SellFAQ from '../../modules/react-sell-faq';
import SellMarketing from '../../modules/react-sell-marketing';
import Partners from '../../modules/react-sell-partners';
import ReadyToSell from '../../modules/react-sell-ready';
import SellSearch from '../../modules/react-sell-search';
import SocialProof from '../../modules/react-social-proof';
import { SELL_HUB_EVENTS } from '../../tracking/track-enum';

import controller from './controller';

import './index.scss';

@connect(controller)
@withHeader
export class SellHubPage extends Component {
  constructor() {
    super();
    this.state = {
      showResult: false,
    };
  }

  static propTypes = {
    query: PropTypes.object.isRequired,
  };

  componentDidMount() {
    publish(SELL_HUB_EVENTS.LOADED);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { searchE } = nextProps.query;
    if (searchE) {
      this.setState({
        showResult: true,
      });
    } else {
      this.setState({
        showResult: false,
      });
    }
  }

  render() {
    const { deviceType, shstoreId, lang, onModalSearchActiveChanged } =
      this.props;

    return (
      <>
        <SellSearch
          deviceType={deviceType}
          onModalSearchActiveChanged={onModalSearchActiveChanged}
        />
        <div className="SellHub">
          <BrandDriver />
          <SocialProof />
          <SellMarketing />
          <FeatureToggle name="sellhub.partnerModule">
            <Partners shstoreId={shstoreId} />
          </FeatureToggle>
          <SellFAQ lang={lang} shstoreId={shstoreId} />
          <ReadyToSell />
        </div>
      </>
    );
  }
}

export default SellHubPage;
